import React from "react";
import { useArbeitszeitStore } from "../../../store/zustandArbeitszeitenStore";
import IWKorrektur from "./IWKorrektur";

type KorrekturModalWrapperProps = {
  handleKorrekturIstZeit: (values: any) => void;
};

function KorrekturModalWrapper(props: KorrekturModalWrapperProps) {
  const setIsModalKorrekturVisible = useArbeitszeitStore(state => state.setIsModalKorrekturVisible);

  return (
    <IWKorrektur 
      closeAction={setIsModalKorrekturVisible}
      submitAction={props.handleKorrekturIstZeit}
    />
  );
}

export default React.memo(KorrekturModalWrapper);